function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1285 -110) translate(1285 110)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#0D0735",
  transform: "translate(10 9)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 3,
  y: 2,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 6,
  x: 13,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 6,
  x: 4,
  y: 7,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 6,
  x: 11,
  y: 15,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 3,
  y: 9,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 3,
  y: 16,
  rx: 1.5
})))));

function SvgFilters(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjg1IC0xMTApIHRyYW5zbGF0ZSgxMjg1IDExMCkiPgogICAgICAgICAgICAgICAgPGcgZmlsbD0iIzBEMDczNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAgOSkiPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIzIiB5PSIyIiByeD0iMS41Ii8+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iNiIgeD0iMTMiIHJ4PSIxLjUiLz4KICAgICAgICAgICAgICAgICAgICA8cmVjdCB3aWR0aD0iMyIgaGVpZ2h0PSI2IiB4PSI0IiB5PSI3IiByeD0iMS41Ii8+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iNiIgeD0iMTEiIHk9IjE1IiByeD0iMS41Ii8+CiAgICAgICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjMiIHk9IjkiIHJ4PSIxLjUiLz4KICAgICAgICAgICAgICAgICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMyIgeT0iMTYiIHJ4PSIxLjUiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFilters as ReactComponent };